import { find } from 'lodash'

/**
 * @typedef {object} fileData
 * @property {string} active
 * @property {string} code
 * @property {string} name
 * @property {string} definition
 * @property {string} category
 * @property {string} subcategory
 */

/**
 * @typedef {object} categoryData
 * @property {string} category
 * @property {{label: string, value: string[]}[]} subcategories
 */

/**
 * @typedef {object} parsedData
 * @property {string} category
 * @property {{label: string, value: string}[]} subcategories
 */

/**
 * Parse categories data
 * @param {fileData[]} file
 * @return {parsedData[]}
 */
const parseData = (file) => {

  /** @type {Object.<string, categoryData>} */
  const data = {}

  file.forEach((file) => {
    if (data[file.category]) {
      const subCategory = find(data[file.category].subcategories, ['label', file.subcategory])
      if (!subCategory) {
        data[file.category].subcategories.push({
          label: file.subcategory,
          value: [file.code]
        })
      } else {
        subCategory.value.push(file.code)
      }
    } else {
      data[file.category] = {
        category: file.category,
        subcategories: [{
          label: file.subcategory,
          value: [file.code]
        }],
      }
    }
  })

  /** @type categoryData[] */
  const parsedData = Object.values(data)

  return parsedData.map((data) => ({
    category: data.category,
    subcategories: data.subcategories.map((subCat) => ({
      ...subCat,
      value: subCat.value.join('|')
    }))
  }))

}

export default parseData
